import { Box } from '@mui/material'
import Lottie from 'lottie-react'

import loadingAnimation from './loading.json'

interface LoadingIndicatorProps {
  size?: number
}

const LoadingIndicator = ({ size = 60 }: LoadingIndicatorProps) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
      }}
    >
      <Lottie animationData={loadingAnimation} loop />
    </Box>
  )
}

export default LoadingIndicator
